/*
  Logic to display all locations drawer when the "check other stores"
  button is clicked under the delivery options on the pdp. It displays
  once the js loads to make sure the user has js enabled, then when its
  clicked it takes the store list from the location-widget and adds a 
  class to it that modifies its html to fit the use case for this UI.
  Lastly it adds event listeners to "close" this drawer by removing 
  the modifier class
*/

if (!customElements.get('delivery-methods')) {
  class DeliveryMethods extends HTMLElement {
    constructor() {
      super();

      this.stores = null;
      this.exits = null;

      this.init();
    }

    init() {
      this.buttons = this.querySelectorAll(".main-product__delivery-methods__button");
      this.pickupStoresData = this.getPickupStoresData();

      this.buttons.forEach((button) => {
        button.classList.remove("__loading");
      })

      this.setupListeners();
    }


    setupListeners() {
      this.buttons.forEach((button) => {
        button.addEventListener('click', () => {
          if (this.stores == null || this.exits == null ){
            this.stores = document.querySelector("location-widget");
            this.exits = this.stores.querySelectorAll(".buff-meganav__dropdown, .buff-meganav__location-widget__actions__alt-label svg")

            this.exits.forEach((exit) => {
              exit.addEventListener('click', (e) => {
                if (e.target === exit) {
                  this.toggleDrawer(false);
                }
              });
            }) 
          }

          this.toggleDrawer(true);
        });
      })
    }

    getPickupStoresData() {
      const data = this.querySelector('[type="application/json"][data-type="pickup-locations"]');

      if (!data) return [];

      try {
        return JSON.parse(data.textContent);
      } catch (error) {
        console.error(error);
        return [];
      }
    }

    locationHasProductPickup(location) {
      const store = this.pickupStoresData.find((pickupStore) => {
        if (typeof pickupStore === 'string') {
          return pickupStore === location.dataset.storeNumber;
        }

        return pickupStore.storeNumber === location.dataset.storeNumber;
      });

      if (typeof store === 'string') return true;

      return store?.pickupEnabled === true && store?.available === true;
    }

    toggleDrawer(open) {
      let locations = this.stores?.querySelectorAll(".buff-meganav__location-widget__stores__store");

      if (open == true){
        this.stores?.classList.add("__layout-display-drawer");
        document.body.style.overflow = 'hidden';

        locations.forEach((location) => {
          if (!this.locationHasProductPickup(location)) {
            location.classList.add("__no-pickup-for-product");
          }
        })
      } else {
        this.stores?.classList.remove("__layout-display-drawer");
        document.body.style.overflow = '';

        locations.forEach((location) => {
            location.classList.remove("__no-pickup-for-product");
        })
      }
    }

    render(productVariant) {
      fetch(`${window.Shopify.routes.root}variants/${productVariant}?section_id=main-product`)
        .then(response => response.text())
        .then(text => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const deliveryMethods = html.querySelector('delivery-methods');

          if (!deliveryMethods) return;

          this.innerHTML = deliveryMethods.innerHTML;
          this.init();
        })
        .catch(error => {
          console.error(error);
        });
    }
  }

  customElements.define('delivery-methods', DeliveryMethods);
}


/* 
  0ld pickupavailability.js below from accelerator. Basically used by
  variant-select.js to update the module

  class PickupAvailability extends HTMLElement {
  constructor() {
    super();
    
    this.errorTemplate = this.querySelector('template');
    this.render(this.dataset.productVariant);
  }

  render(productVariant) {
    fetch(`${window.Shopify.routes.root}variants/${productVariant}?section_id=pickup-availability`)
      .then(response => response.text())
      .then(text => {
        const html = new DOMParser().parseFromString(text, 'text/html').querySelector('.shopify-section');
        this.innerHTML = html.innerHTML;
      })
      .catch(error => {
        this.innerHTML = this.errorTemplate ? this.errorTemplate.innerHTML : error.message;
        console.error(error);
      });
  }
}

customElements.define('pickup-availability', PickupAvailability);
*/
